import { Eye } from 'lucide-react';
import { PERSONAL_VISIBILITY_NOTICE } from '../../data/visibilityModelCopy';
import type { VisibilityModelResult } from '../../types/result';
import { SectionHeading } from './SectionHeading';

interface VisibilityModelSectionProps {
  visibilityModel: VisibilityModelResult;
}

/** Empfohlenes Sichtbarkeitsmodell (Abschnitt 20). */
export function VisibilityModelSection({ visibilityModel }: VisibilityModelSectionProps) {
  return (
    <section className="card stack">
      <SectionHeading icon={Eye}>Empfohlenes Sichtbarkeitsmodell</SectionHeading>
      <p className="pill">{visibilityModel.label}</p>
      <p>{visibilityModel.summary}</p>
      <p>{PERSONAL_VISIBILITY_NOTICE}</p>
    </section>
  );
}
